<template>
  <div class="g-wrapper" @click="closeNav($event)">
    <img
      :src="require('../assets/forum' + Number(index + 1) + '/cover.png')"
      alt=""
      class="u-banner-img"
    />
    <div class="g-forumMain">
      <div class="m-block">
        <img
          :src="require('../assets/forum' + Number(index + 1) + '/intr.png')"
          alt=""
          class="u-forumIcon"
        />
        <p class="u-intrText">
          {{ forum.desc }}
        </p>
      </div>
      <img src="../assets/hr.png" alt="" class="u-hr" />

      <!-- 直播 -->
      <div class="m-block">
        <img
          :src="require('../assets/forum' + Number(index + 1) + '/live.png')"
          alt=""
          class="u-forumIcon"
        />

        <a :href="forum.live">
          <img
            :src="require('../assets/forum' + Number(index + 1) + '/live.jpg')"
            alt=""
            class="u-live-img"
          />
        </a>
      </div>
      <img src="../assets/hr.png" alt="" class="u-hr" />
      <!-- 嘉宾 -->
      <div class="m-block">
        <img
          :src="require('../assets/forum' + Number(index + 1) + '/guest.png')"
          alt=""
          class="u-forumIcon"
        />
        <p class="u-hint">嘉宾按议程排序</p>
        <div class="g-guestList">
          <div
            class="m-guestItem"
            v-for="(item, index) in forumGeusts"
            :key="index"
            @click="showGuestLayer(index)"
          >
            <div class="u-imgBox">
              <img :src="item.detail['img_嘉宾照片']" alt="" />
            </div>
            <div class="u-gusetName">{{ item.detail["姓名"] }}</div>
            <div class="u-guestPos">
              {{ item.detail["职位"] }}
            </div>
          </div>
        </div>
      </div>
      <img src="../assets/hr.png" alt="" class="u-hr" />

      <!-- 议程 -->
      <div class="m-block m-agendaSpecial">
        <img
          :src="require('../assets/forum' + Number(index + 1) + '/agenda.png')"
          alt=""
          class="u-forumIcon"
        />

        <div :class="'m-agndaBox u-agenda' + Number(index + 1)">
          <div class="u-line"></div>
          <div
            class="m-agendaMsg"
            v-for="(item, agendaIndex) in agenda"
            :key="agendaIndex"
            v-if="item.agenda.length > 0"
          >
            <div class="u-timeTag">{{ item.date }}</div>
            <div
              class="u-agndaTitle"
              v-if="
                !(
                  agendaIndex == 1 &&
                  item.title == '2021第十届中国上市公司高峰论坛'
                )
              "
            >
              {{ item.title }} <br />{{ item.forumTheme }}
            </div>
            <div class="u-agandaItem" v-for="(a, b) in item.agenda" :key="b">
              <span class="u-doit"></span>
              <div class="u-timeArea">{{ a.time }}</div>
              <div class="u-seeion">
                <b>{{ a.text[0].replace("=", " ") }}</b>
                <div
                  v-for="(c, cIndex) in a.text"
                  :key="cIndex"
                  v-if="cIndex > 0"
                  class="u-agendaGuestName"
                >
                  <span
                    :class="
                      c.split('=')[0] == '对话嘉宾：' ||
                      c.split('=')[0] == '主持人：'
                        ? 'bloder'
                        : ''
                    "
                  >
                    <abbr v-for="(j, k) in c.split('=')[0]" :key="k">
                      {{ j }}
                    </abbr>
                  </span>
                  <span>
                    {{ c.split("=")[1] }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img src="../assets/hr.png" alt="" class="u-hr" />
      <!-- 论坛新闻 -->
      <div class="m-block">
        <img
          :src="require('../assets/forum' + Number(index + 1) + '/news.png')"
          alt=""
          class="u-forumIcon"
        />
        <ul class="m-liveList">
          <li v-for="(item, index) in newsList" :key="index">
            <img :src="item.thumbnail_url" alt="" class="u-liveThub" />
            <div class="u-liveMsg">
              <a :href="item.article_url" class="u-liveTitle">{{
                item.title
              }}</a>
              <div class="u-liveStatus">
                <p class="u-publish">{{ item.published_at_str }}</p>
              </div>
            </div>
          </li>
        </ul>

        <router-link :to="'/articleList/'+forum.cloumnId" class="u-moreNews" v-if='newsList.length>=10'>
          <img src="../assets/icon5.png" alt=""/>
          查看更多新闻
        </router-link>
      </div>

      <img src="../assets/hr.png" alt="" class="u-hr" />

      <!-- 重磅推荐 -->
      <div v-if="forum.isHavezhongbang">
        <div class="m-block">
          <img
            :src="
              require('../assets/forum' + Number(index + 1) + '/zhongbang.png')
            "
            alt=""
            class="u-forumIcon"
          />

          <a
            :href="item.url == '' ? 'javascript:void(0)' : item.url"
            rel="noopener noreferrer"
            class="u-zhongbangImg"
            v-for="(item, c) in forum.zhongbang"
            :key="c"
          >
            <img
              :src="require('../assets/zhongbang' + Number(item.name) + '.png')"
              @click="alertMsg(item.url)"
            />
          </a>
        </div>

        <img src="../assets/hr.png" alt="" class="u-hr" />
      </div>

      <!-- 组织架构 -->
      <div class="m-block">
        <img
          :src="require('../assets/forum' + Number(index + 1) + '/zuzi.png')"
          alt=""
          class="u-forumIcon"
        />

        <img
          :src="require('../assets/forum' + Number(index + 1) + '/jigou.png')"
          :class="index == 0 ? 'u-zuzi index0' : 'u-zuzi'"
        />
      </div>
    </div>
    <img src="../assets/logo.png" alt="" class="u-logo" />

    <!-- 弹窗 -->
    <div class="g-layer" v-show="isLayerShow">
      <div class="m-gusetDesc">
        <div class="u-imgBox">
          <img :src="geustLayer.detail['img_嘉宾照片']" alt="" />
        </div>
        <div class="u-gusetName">{{ geustLayer.detail["姓名"] }}</div>
        <div class="u-guestPos">{{ geustLayer.detail["职位"] }}</div>
        <img src="../assets/icon3.png" alt="" class="u-icon3" />
        <div class="u-guestIntr">
          {{ geustLayer.detail["简介"] }}
        </div>
      </div>
      <img
        src="../assets/icon4.png"
        alt=""
        class="u-icon4"
        @click="isLayerShow = false"
      />
    </div>

    <!-- 菜单 -->
    <div
      :class="isNavShow ? 'g-nav' : 'g-nav hide'"
      @click.stop="hideLayer($event)"
      id="nav"
    >
      <ul>
        <li
          v-for="(item, index) in navList"
          :key="index"
          @click.stop="changeforunIndex(index)"
        >
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import forumData from "../data/forumData.js";
import wxShare from "../data/share.js";
export default {
  data() {
    return {
      forum: [],
      agenda: [],
      index: "",
      forumGeusts: [],
      isLayerShow: false,
      activeGuestIndex: 0,
      navList: [
        "论坛介绍",
        "论坛直播",
        "论坛嘉宾",
        "论坛议程",
        "论坛新闻",
        "重磅发布",
        "组织机构",
      ],
      geustLayer: {
        detail: {
          img_嘉宾照片: "",
          姓名: "",
          简介: "",
          职位: "",
          论坛: "",
        },
      },
      isNavShow: false,
      newsList: [],
    };
  },
  methods: {
    alertMsg(url) {
      if (url == "") {
        alert("敬请期待！");
      }
    },
    closeNav(event) {
      console.log(event.currentTarget);
      this.isNavShow = false;
    },
    changeforunIndex(index) {
      this.activeforumIndex = index;
      this.isNavShow = false;
      $(".g-wrapper").animate(
        {
          scrollTop:
            $(".m-block").eq(index).offset().top + $(".g-wrapper").scrollTop(),
        },
        500
      );
    },
    hideLayer(event) {
      if (event.currentTarget.id == "nav") {
        this.isNavShow = !this.isNavShow;
      }
    },
    showGuestLayer(index) {
      if (this.forumGeusts[index].detail["简介"] == "") {
        return false;
      }
      this.isLayerShow = true;
      this.geustLayer = this.forumGeusts[index];
    },
    getAgenda(forumName, forumTheme) {
      let that = this;
      $.ajax({
        url:
          "http://www.nbd.com.cn/zhuanti/cfg_stores/get_by_activity_name?activity_name=" +
          forumName +
          "&cfg_type=array&t=" +
          Date.parse(new Date()),
        methods: "get",
        success: function (data) {
          console.log(data);
          let newAgendaList = [
            {
              date: "上午",
              agenda: [],
              title: forumName,
              forumTheme: forumTheme,
            },
            {
              date: "下午",
              agenda: [],
              title: forumName,
              forumTheme: forumTheme,
            },
          ];

          data.cfg.map((item) => {
            let agendaItem = {};
            agendaItem.time = item["时间"];
            if (item["内容以&符号解析成换行"]) {
              agendaItem.text = item["内容以&符号解析成换行"].split("&");
            } else {
              agendaItem.text = [];
            }

            if (item["上/下午"] == "上午") {
              newAgendaList[0].agenda.push(agendaItem);
            } else {
              newAgendaList[1].agenda.push(agendaItem);
            }
          });
          console.log(newAgendaList);
          that.agenda = newAgendaList;
        },
      });
    },

    getGuestList() {
      let that = this;
      $.ajax({
        url: "http://www.nbd.com.cn/zhuanti/activity_enters.json?activity_name=2021%E5%B3%B0%E4%BC%9A%E5%98%89%E5%AE%BE&status=0",
        methods: "get",
        success: function (data) {
          console.log(data);
          let guestList = data.infos;
          let guestArray = [];
          guestList.map((item) => {
            if (that.forum.name.includes(item.detail["论坛"])) {
              guestArray.push(item);
            }
          });

          that.forumGeusts = guestArray;

          // that.guestList = data.infos;
          // that.geustLayer = data.infos[0];
        },
      });
    },

    getNews(id) {
      let that = this;
      $.ajax({
        url:
          "http://www.nbd.com.cn/columns/" +
          id +
          "/articles_list.json?per=10&page_index=1&simple_info=1",
        methods: "get",
        success: function (data) {
          console.log("--news--");
          console.log(data);
          that.newsList = data;
        },
      });
    },
  },
  mounted() {
    console.log(forumData);
    this.forum = forumData[Number(this.$route.params.id) - 1];
    this.index = Number(this.$route.params.id) - 1;
    this.getGuestList();
    console.log(this.forum);
    if (this.index != 8) {
      this.getAgenda(this.forum.name, this.forum.theme);
    } else {
      this.getAgenda(
        "2021中国上市公司品牌价值蓝皮书",
        "暨2021中国资本市场荣誉盛典"
      );
    }

    if (this.forum.isHavezhongbang) {
      this.navList = [
        "论坛介绍",
        "论坛直播",
        "论坛嘉宾",
        "论坛议程",
        "论坛新闻",
        "重磅发布",
        "组织机构",
      ];
    } else {
      this.navList = [
        "论坛介绍",
        "论坛直播",
        "论坛嘉宾",
        "论坛议程",
        "论坛新闻",
        "组织机构",
      ];
    }

    this.getNews(this.forum.cloumnId);
    wxShare(
      this.forum.shareTtile,
      this.forum.shareDesc,
      location.href,
      "http://www.nbd.com.cn/corp/m-2021fenghui/" +
        require("../assets/forum" + Number(this.index + 1) + "/cover.png")
    );
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.g-wrapper {
  background: #dbdbde;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 750px;
  overflow-y: auto;
  overflow-x: hidden;
}
.u-forumIcon {
  width: 501px;
  height: 124px;
  display: block;
  margin: 0 auto;
  margin-bottom: 30px;
}
.m-block {
  position: relative;
  z-index: 999;
  // overflow: hidden;
}

.g-forumMain {
  width: 730px;
  padding: 32px;
  box-sizing: border-box;
  margin: 0 auto;
  background: #fff;
  overflow: hidden;
  .u-intrText {
    text-indent: 2em;
    font-size: 30px;
    color: #535353;
    line-height: 1.5;
    margin-bottom: 10px;
  }
  .u-hr {
    width: auto;
    height: 28px;
    display: block;
    margin: 30px -32px;
  }
}
.m-liveList {
  width: 100%;
  li {
    list-style: none;
    display: flex;
    justify-content: space-between;
    margin-bottom: 60px;
    .u-liveThub {
      width: 280px;
      height: 160px;
    }
    .u-liveMsg {
      width: 355px;
      flex-direction: column;
      display: flex;
      justify-content: space-between;
    }
    .u-liveTitle {
      color: #535353;
      font-size: 28px;
      text-align: justify;
      text-decoration: none;
    }
    .u-liveStatus {
      display: inline-flex;
      justify-content: space-between;
      align-items: flex-end;
      flex-wrap: nowrap;
    }
    .u-liveTag {
      padding: 5px 10px;
      background: #e9e9eb;
      color: #1a75df;
      font-size: 20px;
      text-align: center;
      &.u-onLive {
        color: #f41538;
      }
    }
    .u-publish {
      font-size: 20px;
      color: #9e9e9e;
    }
  }
}
.u-icon6 {
  width: 21px;
  height: 21px;
}

.g-guestList {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.m-guestItem {
  width: 280px;
  color: #202020;
  font-size: 30px;
  margin-bottom: 80px;
}
.u-imgBox {
  width: 245px;
  height: 245px;
  border-radius: 50%;
  background: #e5e5e5;
  margin: 0 auto;
  overflow: hidden;
  margin-bottom: 20px;
  img {
    max-width: 100%;
  }
}
.u-gusetName {
  font-weight: bolder;

  padding-bottom: 15px;
  border-bottom: 1px solid #b7b7b7;
}
.u-guestPos {
  line-height: 1.4;
  margin-top: 15px;
}
.u-iconTime {
  width: 29px;
  height: 29px;
  margin-right: 15px;
}
.u-agndaTime {
  height: 46px;
  width: 699px;
  color: #fff;
  display: flex;
  justify-content: flex-start;
  padding-left: 30px;
  box-sizing: border-box;
  align-items: center;
  z-index: 999;
  position: relative;
  .u-time {
    font-size: 32px;
    margin-left: 15px;
  }
  .u-week {
    font-size: 20px;
    margin-left: 40px;
  }
  //   &.u-agenda1bg {
  //     background: url("../assets/agenda1Bg.png") no-repeat;
  //     background-size: 100% 100%;
  //   }
}
.m-agndaBox {
  // margin-top: 46px;
  position: relative;
  &.u-agenda1 {
    .u-agndaTime {
      background: url("../assets/agenda1Bg.png") no-repeat;
      background-size: 100% 100%;
    }
    .u-timeTag {
      background: #034782;
    }
    .u-agndaTitle {
      color: #034782;
    }
    .u-doit {
      background: #034782;
    }
    .u-timeArea {
      color: #034782;
    }
  }
  &.u-agenda2 {
    .u-agndaTime {
      background: url("../assets/agenda2Bg.png") no-repeat;
      background-size: 100% 100%;
    }
    .u-timeTag {
      background: #a68463;
    }
    .u-agndaTitle {
      color: #a68463;
    }
    .u-doit {
      background: #a68463;
    }
    .u-timeArea {
      color: #a68463;
    }
  }

  &.u-agenda3 {
    .u-timeTag {
      background: #5f93d3;
    }
    .u-agndaTitle {
      color: #5f93d3;
    }
    .u-doit {
      background: #5f93d3;
    }
    .u-timeArea {
      color: #5f93d3;
    }
  }

  &.u-agenda4 {
    .u-agndaTime {
      background: url("../assets/agenda3Bg.png") no-repeat;
      background-size: 100% 100%;
    }
    .u-timeTag {
      background: #5d40ac;
    }
    .u-agndaTitle {
      color: #5d40ac;
    }
    .u-doit {
      background: #5d40ac;
    }
    .u-timeArea {
      color: #5d40ac;
    }
  }

  &.u-agenda5 {
    .u-timeTag {
      background: #0a9995;
    }
    .u-agndaTitle {
      color: #0a9995;
    }
    .u-doit {
      background: #0a9995;
    }
    .u-timeArea {
      color: #0a9995;
    }
  }
  &.u-agenda6 {
    .u-agndaTime {
      background: url("../assets/agenda4Bg.png") no-repeat;
      background-size: 100% 100%;
    }
    .u-timeTag {
      background: #283d9e;
    }
    .u-agndaTitle {
      color: #283d9e;
    }
    .u-doit {
      background: #283d9e;
    }
    .u-timeArea {
      color: #283d9e;
    }
  }
  &.u-agenda7 {
    .u-timeTag {
      background: #c8070a;
    }
    .u-agndaTitle {
      color: #c8070a;
    }
    .u-doit {
      background: #c8070a;
    }
    .u-timeArea {
      color: #c8070a;
    }
  }
  &.u-agenda8 {
    .u-agndaTime {
      background: url("../assets/agenda5Bg.png") no-repeat;
      background-size: 100% 100%;
    }
    .u-timeTag {
      background: #f48d27;
    }
    .u-agndaTitle {
      color: #f48d27;
    }
    .u-doit {
      background: #f48d27;
    }
    .u-timeArea {
      color: #f48d27;
    }
  }
  &.u-agenda9 {
    .u-timeTag {
      background: #a2400f;
    }
    .u-agndaTitle {
      color: #a2400f;
    }
    .u-doit {
      background: #a2400f;
    }
    .u-timeArea {
      color: #a2400f;
    }
  }
  .u-line {
    width: 1px;
    height: 800000000px;
    background: #dbdbde;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 200;
  }
}
.m-agendaMsg {
  margin-top: 20px;
}
.u-timeTag {
  width: 100px;
  height: 40px;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
  color: #fff;
  font-size: 26px;
  line-height: 40px;
  text-align: center;
}
.u-agndaTitle {
  font-size: 36px;
  text-align: justify;
  //   line-height: 1.2;
  width: 668px;
  height: 100px;
  padding-left: 45px;
  box-sizing: border-box;
  background: #eeeeee;
  border-top-right-radius: 64px;
  border-bottom-right-radius: 64px;
  margin-top: 22px;
  align-items: center;
  display: flex;
}
.u-agandaItem {
  display: flex;
  flex-direction: row;
  align-items: top;
  margin-top: 30px;
}
.u-doit {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-top: 22px;
  margin-left: -7px;
  position: relative;
  z-index: 999;
  flex-shrink: 0;
}

.u-timeArea {
  width: 225px;
  height: 45px;
  border-radius: 25px;
  background: #eee;
  font-size: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  font-weight: bolder;
  flex-shrink: 0;
}
.u-seeion {
  font-size: 26px;
  color: #313131;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  align-self: center;
}
.u-logo {
  width: 164px;
  height: 44px;
  margin: 60px auto;
  display: block;
}

.m-agendaSpecial {
  margin: 0 -32px;
  overflow: hidden;
  padding: 0 32px;
}

.g-layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.5);
  z-index: 99999;
}
.m-gusetDesc {
  padding: 45px 70px;
  width: 615px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 5px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .u-gusetName {
    text-align: center;
    margin-top: 25px;
  }
  .u-guestPos {
    text-align: center;
  }
}
.u-icon3 {
  width: 100%;
  height: 7px;
  margin: 20px auto;
  display: block;
}
.u-guestIntr {
  text-indent: 2em;
  color: #202020;
  font-size: 30px;
  line-height: 1.4;
  height: 400px;
  overflow-y: auto;
  text-align: justify;
}
.u-icon4 {
  height: 73px;
  width: 73px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 60px;
}

.g-nav {
  position: fixed;
  width: 269px;
  height: 454px;
  top: 150px;
  right: 0;
  background: url("../assets/icon9.png") no-repeat;
  background-size: 100% 100%;
  z-index: 999;
  padding-left: 120px;
  box-sizing: border-box;
  transition: all 0.5s;
  &.hide {
    right: -165px;
  }
  ul {
    width: 100%;
    margin: 0;
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;
    box-sizing: border-box;
    li {
      padding-bottom: 10px;
      border-bottom: 1px solid #21599e;
      font-size: 29px;
      color: #fff;
      list-style: none;
      &:last-child {
        border: none;
      }
    }
  }
}
.u-live-img {
  width: 669px;
  height: 375px;
  display: block;
}
.u-zhongbangImg {
  width: 600px;
  height: 110px;
  display: block;
  margin: 0 auto;
  margin-bottom: 10px;
  img {
    width: 100%;
  }
}
.u-zuzi {
  width: 416px;
  display: block;
  margin: 0 auto;
  &.index0 {
    width: 621px;
  }
}
.u-hint {
  font-size: 14px;
  text-align: center;
  margin-bottom: 20px;
}
.u-agendaGuestName {
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  overflow: hidden;
  span {
    &:first-child {
      min-width: 100px;
      text-align: justify;
      margin-right: 15px;
      flex-shrink: 0;
      text-align-last: justify;
      // -webkit-text-align-last: justify;
      white-space: nowrap;
      display: flex;
      justify-content: space-between;
      .i {
        width: 100%;
        display: block;
      }
      &.bloder {
        font-weight: bolder;
        margin: 10px 0;
      }
    }
    &:last-child {
      width: 290px;
    }
  }
}
.u-moreNews {
  width: 260px;
  height: 45px;
  border: 1px solid #4383b8;
  display: block;
  margin: 20px auto;
  color: #4383b8;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 32px;
    height: 22px;
    margin-right: 10px;
  }
  font-size: 26px;
}
</style>